__webpack_require__.p = "/wp-content/plugins/tror-event-search/frontend/build/";